import React, { useRef, useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import { ReactComponent as Close } from "./close.svg";
import { useNavigate } from "react-router-dom";
import Turnstile from "./Turnstile";
import ProgressBar from "./ProgressBar";
import LoadingSpinner from "./LoadingSpinner";
import { API_URL } from "./Consts";

export default function Portal() {
  const navigate = useNavigate();
  const steamIDInput = useRef();
  const [token, setToken] = useState(null);
  const [verificationResult, setVerificationResult] = useState(null);
  const [searching, setSearching] = useState(false);
  const [berserkerProgress, setBerserkerProgress] = useState(0);
  const [sharpshooterProgress, setSharpshooterProgress] = useState(0);
  const [supportProgress, setSupportProgress] = useState(0);
  const [support2Progress, setSupport2Progress] = useState(0);
  const [medicProgress, setMedicProgress] = useState(0);
  const [commandoProgress, setCommandoProgress] = useState(0);
  const [commando2Progress, setCommando2Progress] = useState(0);
  const [firebugProgress, setFirebugProgress] = useState(0);
  const [demolitionProgress, setDemolitionProgress] = useState(0);
  const [killCount, setKillCount] = useState(0);
  const [winCount, setWinCount] = useState(0);
  const [specialRole, setSpecialRole] = useState(null);
  const [expiration, setExpiration] = useState(null);
  const [currentPerk, setCurrentPerk] = useState(null);
  const [currentPerkImg, setCurrentPerkImg] = useState(null);
  const [currentPlayer, setCurrentPlayer] = useState(null);
  const [perkLevels, setPerkLevels] = useState(null);
  const [currentPerkStats, setCurrentPerkStats] = useState(null);
  const [currentPerkRequirements, setCurrentPerkRequirements] = useState(null);
  const [currentChar, setCurrentChar] = useState(null);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [currentSteamID, setCurrentSteamID] = useState("");
  const portalBoxRef = useRef(null);

  useEffect(() => {
    if (verificationResult != null) {
      return;
    }

    const currentSteamID = localStorage.getItem("csteamid");

    if (currentSteamID) {
      steamIDInput.current.value = currentSteamID;
    }
  }, [verificationResult]);

  const goToShop = () => {
    navigate("/shop");
  };

  const goToMain = () => {
    navigate("/");
  };

  const resetSearch = () => {
    setVerificationResult(null);
    setToken(null);
    setBerserkerProgress(0);
    setSharpshooterProgress(0);
    setSupportProgress(0);
    setSupport2Progress(0);
    setMedicProgress(0);
    setCommandoProgress(0);
    setCommando2Progress(0);
    setFirebugProgress(0);
    setDemolitionProgress(0);
    setSpecialRole(null);
    setExpiration(null);
    setCurrentPerk(null);
    setCurrentPlayer(null);
    setPerkLevels(null);
    setIsImageLoaded(false);
    setSearching(false);
  };

  const handleVerify = (token) => {
    setToken(token);
  };

  function handlePlayerStats(player_stats) {
    let perkCurrent = [];
    let perkRequirement = [];
    let perkLevels = [];
    setCurrentPlayer(player_stats[0]);
    setCurrentPerk(player_stats[1]);
    if (player_stats[1] && player_stats[1] != "") {
      setCurrentPerkImg(player_stats[1]);

      if (player_stats[1] == "Support Specialist") {
        setCurrentPerkImg("Support");
      }
    }

    perkLevels.push(
      GetCurrentPerkLevel("Medic", player_stats[2]),
      GetCurrentPerkLevel(
        "Support Specialist",
        player_stats[4],
        player_stats[3],
      ),
      GetCurrentPerkLevel("Sharpshooter", player_stats[5]),
      GetCurrentPerkLevel("Commando", player_stats[7], player_stats[6]),
      GetCurrentPerkLevel("Berserker", player_stats[8]),
      GetCurrentPerkLevel("Firebug", player_stats[9]),
      GetCurrentPerkLevel("Demolition", player_stats[11]),
    );

    setPerkLevels(perkLevels);

    perkCurrent.push(
      player_stats[2],
      player_stats[4],
      player_stats[3],
      player_stats[5],
      player_stats[7],
      player_stats[6],
      player_stats[8],
      player_stats[9],
      player_stats[11],
    );

    setKillCount(player_stats[10]);
    setWinCount(player_stats[20]);
    perkRequirement.push(
      RequirementByLevel(perkLevels[0] + 1, "Medic"),
      RequirementByLevel(perkLevels[1] + 1, "Support Specialist"),
      SecondRequirementByLevel(perkLevels[1] + 1, "Support Specialist"),
      RequirementByLevel(perkLevels[2] + 1, "Sharpshooter"),
      RequirementByLevel(perkLevels[3] + 1, "Commando"),
      SecondRequirementByLevel(perkLevels[3] + 1, "Commando"),
      RequirementByLevel(perkLevels[4] + 1, "Berserker"),
      RequirementByLevel(perkLevels[5] + 1, "Firebug"),
      RequirementByLevel(perkLevels[6] + 1, "Demolition"),
    );

    setCurrentPerkRequirements(perkRequirement);
    setCurrentPerkStats(perkCurrent);

    setMedicProgress(
      perkLevels[0] == 80 ? 100 : 100 * (perkCurrent[0] / perkRequirement[0]),
    );
    setSupportProgress(
      perkLevels[1] == 80 ? 100 : 100 * (perkCurrent[1] / perkRequirement[1]),
    );
    setSupport2Progress(
      perkLevels[1] == 80 ? 100 : 100 * (perkCurrent[2] / perkRequirement[2]),
    );
    setSharpshooterProgress(
      perkLevels[2] == 80 ? 100 : 100 * (perkCurrent[3] / perkRequirement[3]),
    );
    setCommandoProgress(
      perkLevels[3] == 80 ? 100 : 100 * (perkCurrent[4] / perkRequirement[4]),
    );
    setCommando2Progress(
      perkLevels[3] == 80 ? 100 : 100 * (perkCurrent[5] / perkRequirement[5]),
    );
    setBerserkerProgress(
      perkLevels[4] == 80 ? 100 : 100 * (perkCurrent[6] / perkRequirement[6]),
    );
    setFirebugProgress(
      perkLevels[5] == 80 ? 100 : 100 * (perkCurrent[7] / perkRequirement[7]),
    );
    setDemolitionProgress(
      perkLevels[6] == 80 ? 100 : 100 * (perkCurrent[8] / perkRequirement[8]),
    );

    let role = player_stats[21];
    let expiration = player_stats[22];
    if (role === 2) {
      setSpecialRole("Admin");
    } else if (role === 1 && expiration > Date.now() / 1000) {
      setSpecialRole("VIP");
      let left = expiration - Date.now() / 1000;
      let days = Math.floor(left / (60 * 60 * 24));
      let hours = Math.floor((left / (60 * 60)) % 24);
      let minutes = Math.floor((left / 60) % 60);

      setExpiration(days + " d, " + hours + "h, " + minutes + "m");
    } else {
      setSpecialRole("Regular");
    }

    const img = new Image();
    if (player_stats[23].includes("KFOneSkins")) {
      setCurrentChar("Custom_Character");
      img.src = require("./portraits/Custom_Character.png");
    } else {
      setCurrentChar(player_stats[23]);
      img.src = require("./portraits/" + player_stats[23] + ".png");
    }

    img.onload = () => setIsImageLoaded(true);
  }

  function GetCurrentPerkLevel(perkName, currentStat, currentSecondStat) {
    let nextLevelStat = 0;
    let nextLevelSecondStat = 0;
    for (let i = 0; i <= 80; i++) {
      nextLevelStat = RequirementByLevel(i, perkName);
      if (nextLevelStat > currentStat) {
        if (perkName == "Support Specialist" || perkName == "Commando") {
          for (let j = 0; j <= i; j++) {
            nextLevelSecondStat = SecondRequirementByLevel(j, perkName);
            if (nextLevelSecondStat > currentSecondStat) {
              return Math.min(Math.max(0, i - 1), Math.max(0, j - 1));
            }
          }
          return Math.max(0, i - 1);
        } else {
          return Math.max(0, i - 1);
        }
      }
    }

    if (perkName == "Support Specialist" || perkName == "Commando") {
      for (let j = 0; j <= 80; j++) {
        nextLevelSecondStat = SecondRequirementByLevel(j, perkName);
        if (nextLevelSecondStat > currentSecondStat) {
          return Math.max(0, j - 1);
        }
      }
      return 80;
    } else return 80;
  }

  function RequirementByLevel(level, perkName) {
    switch (level) {
      case 0:
        if (perkName == "Berserker") return 5000;
        else if (perkName == "Support Specialist") return 1000;
        else if (perkName == "Medic") return 100;
        else if (perkName == "Sharpshooter") return 10;
        else return 10000;
      case 1:
        if (perkName == "Support Specialist") return 5000;
        else if (perkName == "Sharpshooter") return 30;
        else if (perkName == "Medic") return 200;
        else return 25000;
      case 2:
        if (perkName == "Medic") return 750;
        else if (perkName == "Sharpshooter") return 100;
        else return 100000;
      case 3:
        if (perkName == "Medic") return 4000;
        else if (perkName == "Sharpshooter") return 700;
        else return 500000;
      case 4:
        if (perkName == "Medic") return 12000;
        else if (perkName == "Sharpshooter") return 2500;
        else return 1500000;
      case 5:
        if (perkName == "Medic") return 25000;
        else if (perkName == "Sharpshooter") return 5500;
        else return 3500000;
      case 6:
        if (perkName == "Medic") return 100000;
        else if (perkName == "Sharpshooter") return 8500;
        else return 5500000;
      default:
        if (perkName == "Medic")
          return 100000 + (level - 6) * (level - 6) * 20000;
        else if (perkName == "Sharpshooter")
          return 8500 + (level - 6) * (level - 6) * 2500;
        else return 5500000 + (level - 6) * (level - 6) * 300000;
    }
  }

  function SecondRequirementByLevel(level, perkName) {
    switch (level) {
      case 0:
        if (perkName == "Support Specialist") return 1000;
        else return 10;
      case 1:
        if (perkName == "Support Specialist") return 2000;
        else return 30;
      case 2:
        if (perkName == "Support Specialist") return 7000;
        else return 100;
      case 3:
        if (perkName == "Support Specialist") return 20000;
        else return 350;
      case 4:
        if (perkName == "Support Specialist") return 40000;
        else return 600;
      case 5:
        if (perkName == "Support Specialist") return 70000;
        else return 1100;
      case 6:
        if (perkName == "Support Specialist") return 120000;
        else return 1800;
      default:
        if (perkName == "Support Specialist")
          return 120000 + (level - 6) * (level - 6) * 17500;
        else return 1800 + (level - 6) * (level - 6) * 175;
    }
  }

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (/^\d*$/.test(newValue)) {
      steamIDInput.current.value = newValue;
    }
  };

  async function processPurchase(e, purchaseId) {
    let postBody = { steam_id: currentSteamID, purchase_id: purchaseId };
    resetSearch();
    setSearching(true);
    fetch(API_URL + "/purchase", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postBody),
    })
      .then((response) => {
        if (response.status === 429) {
          throw new Error("429");
        } else if (response.status !== 200) {
          throw new Error("");
        } else {
          return response.json();
        }
      })
      .then((data) => {
        navigate("/handle-purchase");
      })
      .catch((error) => {
        if (error.toString().includes("429")) {
          setVerificationResult("Too many requests. Please try again later.");
        } else {
          setVerificationResult("An error occurred.");
        }
        setSearching(false);
      });
  }

  async function processSearch(e) {
    if (steamIDInput.current.value === "") {
      setVerificationResult("Please fill SteamID field.");
      setSearching(false);
      return;
    }

    if (steamIDInput.current.value.length !== 17) {
      setVerificationResult("SteamID has to be exactly 17 characters long.");
      setSearching(false);
      return;
    }

    if (/^\d+$/.test(steamIDInput.current.value) == false) {
      setVerificationResult("SteamID has to contain only digits.");
      setSearching(false);
      return;
    }

    setSearching(true);
    if (token) {
      let postBody = { token: token, steam_id: steamIDInput.current.value };
      setToken(null);
      fetch(API_URL + "/player-stats", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postBody),
      })
        .then((response) => {
          if (response.status === 429) {
            throw new Error("429");
          } else {
            return response.json();
          }
        })
        .then((data) => {
          if (data.success) {
            if (data.message == null) {
              setVerificationResult("Player not found.");
              setSearching(false);
            } else {
              setCurrentSteamID(postBody["steam_id"]);
              localStorage.setItem("csteamid", postBody["steam_id"]);
              handlePlayerStats(data.message);
              setVerificationResult("Verification successful!");
              const intervalId = setInterval(() => {
                portalBoxRef.current?.scrollIntoView({ behavior: "smooth" });
                clearInterval(intervalId);
              }, 200);
            }
          } else {
            setVerificationResult("Verification failed.");
            setSearching(false);
          }
        })
        .catch((error) => {
          if (error.toString().includes("429")) {
            setVerificationResult("Too many requests. Please try again later.");
          } else {
            console.log(error);
            setVerificationResult("An error occurred.");
          }
          setSearching(false);
        });
    } else {
      setVerificationResult("Please complete the verification first.");
      setSearching(false);
    }
  }

  return (
    <>
      <div className="root">
        <div className="logoContainer">
          <div className="logoSmaller" onClick={() => goToMain()}>
            <b>kfOne</b>
          </div>
          <div className="underLogoSmaller" onClick={() => goToMain()}>
            <b>Killing Floor 1 Server</b>
          </div>
        </div>

        <div
          className={`shopMenu ${
            verificationResult == "Verification successful!" ? "loaded" : ""
          }`}
        >
          <div className="textButtonGroup">
            <div className="portalTitleText">
              <b>Player portal</b>
            </div>
          </div>
          <div className="helpDescription">
            <b>Here you can find your in-game profile, see stats,</b>
          </div>
          <div className="helpDescription">
            <b>or maintain your privilages</b>
          </div>

          <div className="buyButtonContainer">
            {searching ? (
              verificationResult != "Verification successful!" ? (
                <LoadingSpinner />
              ) : (
                <></>
              )
            ) : (
              <div>
                <div className="portalBox">
                  {verificationResult != null ? (
                    <div className="itemErrorText">
                      <b>
                        <p>{verificationResult}</p>
                      </b>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="currentSIDText">(steam id)</div>
                  <input
                    className="portalSteamID form-control inputs shadow-none"
                    ref={steamIDInput}
                    type="text"
                    placeholder="#################"
                    maxLength="17"
                    required
                    onChange={handleChange}
                  />
                  <div className="howToText">
                    <b>
                      <a href="https://help.steampowered.com/en/faqs/view/2816-BE67-5B69-0FEC">
                        How to find your Steam ID?
                      </a>
                    </b>
                  </div>
                </div>
                <div className="turnstile-container">
                  <Turnstile
                    siteKey="0x4AAAAAAAkrHAc_pF4KPEsO"
                    onVerify={handleVerify}
                  />
                  <Button
                    variant="dark"
                    className={`buyButton ${token != null ? "show" : ""}`}
                    onClick={() => processSearch()}
                  >
                    Search player
                  </Button>
                </div>
                <footer>
                  <p>© {new Date().getFullYear()}</p>
                </footer>
              </div>
            )}
          </div>
          {verificationResult == "Verification successful!" && isImageLoaded ? (
            <div>
              <div ref={portalBoxRef} className="portalStatsBox">
                <div className="playerContainer">
                  <div className="groupPortal">
                    <Close className="closeMark" onClick={resetSearch}></Close>
                    <b className="playerNameBoldedText">{currentPlayer}</b>
                  </div>
                </div>
                <div className="containerHor">
                  <div class="corner top-left"></div>
                  <div class="corner top-right"></div>
                  <div class="corner bottom-left"></div>
                  <div class="corner bottom-right"></div>
                  <div className="playerRoleContainer">
                    <div>
                      <div className="playerInfoContainer">
                        <div className="currentPerkText">(player perk)</div>
                        <div className="perkText">{currentPerk}</div>

                        <div class="playerInfoTextContainer">
                          <div className="vipButtonContainer">
                            <div className="currentPerkText">(kill count)</div>
                            <div className="perkText">{killCount}</div>
                          </div>

                          <div className="vipButtonContainer rightVipButtonContainer">
                            <div className="currentPerkText">(win count)</div>
                            <div className="perkText">{winCount}</div>
                          </div>
                        </div>
                        <div className="currentPerkText">(player role)</div>
                        <div className="perkText">{specialRole} player</div>
                        {specialRole == "Regular" ? (
                          <div className="buttonPair">
                            <div className="vipButtonContainer">
                              <Button
                                variant="dark"
                                className="buyVipButton"
                                onClick={() => processPurchase(null, 2)}
                              >
                                Claim VIP for 3 months 0.00 €
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                        {expiration != null ? (
                          <div className="expirationCont">
                            <p>Expires in {expiration}</p>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    <div className="currentPerk">
                      {/* <div className="perkText">{currentPerk}</div> */}
                      {currentPerkImg == null ? (
                        <></>
                      ) : (
                        <img
                          className={`perkImage ${
                            isImageLoaded ? "loaded" : ""
                          }`}
                          src={require("./perks/" + currentPerkImg + ".png")}
                        />
                      )}
                      {/* <div className="currentPerkText">(current perk)</div> */}
                    </div>
                  </div>
                  <div
                    className={`portraitContainer ${
                      isImageLoaded ? "loaded" : ""
                    }`}
                  >
                    <img
                      className={`portrait ${isImageLoaded ? "loaded" : ""}`}
                      src={require("./portraits/" + currentChar + ".png")}
                    />
                  </div>
                </div>

                <div className="perksMenu">
                  <div className="currentStatsText">(stats)</div>

                  <div>
                    <div className="progressHeader">
                      Berserker level {perkLevels[4]}:
                    </div>
                    <ProgressBar
                      progress={berserkerProgress}
                      progressText={
                        perkLevels[4] === 80
                          ? "Max"
                          : currentPerkStats[6] +
                            " / " +
                            currentPerkRequirements[6]
                      }
                    />
                  </div>
                  <div>
                    <div className="progressHeader">
                      Support Specialist level {perkLevels[1]}:
                    </div>
                    <ProgressBar
                      progress={supportProgress}
                      progressText={
                        perkLevels[1] === 80
                          ? "Max"
                          : currentPerkStats[1] +
                            " / " +
                            currentPerkRequirements[1]
                      }
                    />
                    <ProgressBar
                      progress={support2Progress}
                      progressText={
                        perkLevels[1] === 80
                          ? "Max"
                          : currentPerkStats[2] +
                            " / " +
                            currentPerkRequirements[2]
                      }
                    />
                  </div>
                  <div>
                    <div className="progressHeader">
                      Commando level {perkLevels[3]}:
                    </div>
                    <ProgressBar
                      progress={commandoProgress}
                      progressText={
                        perkLevels[3] === 80
                          ? "Max"
                          : currentPerkStats[4] +
                            " / " +
                            currentPerkRequirements[4]
                      }
                    />
                    <ProgressBar
                      progress={commando2Progress}
                      progressText={
                        perkLevels[3] === 80
                          ? "Max"
                          : currentPerkStats[5] +
                            " / " +
                            currentPerkRequirements[5]
                      }
                    />
                  </div>
                  <div>
                    <div className="progressHeader">
                      Firebug level {perkLevels[5]}:
                    </div>
                    <ProgressBar
                      progress={firebugProgress}
                      progressText={
                        perkLevels[5] === 80
                          ? "Max"
                          : currentPerkStats[7] +
                            " / " +
                            currentPerkRequirements[7]
                      }
                    />
                  </div>
                  <div>
                    <div className="progressHeader">
                      Field Medic level {perkLevels[0]}:
                    </div>
                    <ProgressBar
                      progress={medicProgress}
                      progressText={
                        perkLevels[0] === 80
                          ? "Max"
                          : currentPerkStats[0] +
                            " / " +
                            currentPerkRequirements[0]
                      }
                    />
                  </div>
                  <div>
                    <div className="progressHeader">
                      Demolitions level {perkLevels[6]}:
                    </div>
                    <ProgressBar
                      progress={demolitionProgress}
                      progressText={
                        perkLevels[6] === 80
                          ? "Max"
                          : currentPerkStats[8] +
                            " / " +
                            currentPerkRequirements[8]
                      }
                    />
                  </div>
                  <div>
                    <div className="progressHeader">
                      Sharpshooter level {perkLevels[2]}:
                    </div>
                    <ProgressBar
                      progress={sharpshooterProgress}
                      progressText={
                        perkLevels[2] === 80
                          ? "Max"
                          : currentPerkStats[3] +
                            " / " +
                            currentPerkRequirements[3]
                      }
                    />
                  </div>
                </div>
              </div>
              <footer>
                <p>© {new Date().getFullYear()}</p>
              </footer>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
}
